import { render, staticRenderFns } from "./InstructionMinimis.vue?vue&type=template&id=9ba9c100&"
import script from "./InstructionMinimis.vue?vue&type=script&lang=js&"
export * from "./InstructionMinimis.vue?vue&type=script&lang=js&"
import style0 from "./InstructionMinimis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports